import { usdcSymbol, pusdToken } from "../../assets";
import { formatNumberSuffix } from "../../utils";
import { Typography } from "../Typography/Typography";
import * as S from "./ValueBars.styled";

type UsdcBarProps = {
  value: string | number;
  token: string;
  bordered?: boolean;
};

export const UsdcBar = ({ value, token, bordered }: UsdcBarProps) => (
  <S.UsdcBarWrapper bordered={bordered}>
    <S.CoinUsdcIconWrapper>
      <S.UsdcCoinLogo
        src={token === "pUSD" ? pusdToken : usdcSymbol}
        alt="stable coin logo"
      />
    </S.CoinUsdcIconWrapper>
    <Typography.BarUSDCLabel fontWeight={700}>{token}</Typography.BarUSDCLabel>
    <Typography.BarValue fontWeight={700}>
      {value && Number(value) > 0 ? formatNumberSuffix(Number(value)) : "-"}
    </Typography.BarValue>
  </S.UsdcBarWrapper>
);
